import { ProductSize } from "./ProductSize.js";
import type { productSizeKeyMap } from "./productSizeKeyMap.js";

export const productSizeKeyReversedMap: {
	// eslint-disable-next-line no-use-before-define
	[Size in keyof typeof productSizeKeyMap as (typeof productSizeKeyMap)[Size]]: Size;
} = {
	xs: ProductSize.Xs,
	s: ProductSize.S,
	m: ProductSize.M,
	l: ProductSize.L,
};
